// Keep Fit App - 登入頁面

import { useState } from 'react';

interface LoginProps {
  onLogin: () => void;
}

export default function Login({ onLogin }: LoginProps) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // 簡單密碼驗證（密碼存儲在 localStorage）
    // 正確密碼從環境變數獲取，預設為 "keepfit2024"
    const correctPassword = import.meta.env.VITE_APP_PASSWORD || 'keepfit2024';
    
    // 模擬延遲
    await new Promise(resolve => setTimeout(resolve, 500));
    
    if (password === correctPassword) {
      // 保存登入狀態
      localStorage.setItem('keep-fit-auth', 'true');
      localStorage.setItem('keep-fit-login-time', new Date().toISOString());
      onLogin();
    } else {
      setError('密碼不正確');
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="text-6xl mb-4">🍎</div>
          <h1 className="text-2xl font-bold text-gray-800">Keep Fit App</h1>
          <p className="text-gray-500 mt-2">AI 驅動嘅飲食追蹤</p>
        </div>

        {/* 登入表單 */}
        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              請輸入密碼
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="輸入訪問密碼"
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition"
              autoFocus
              disabled={loading}
            />
            {error && (
              <p className="mt-2 text-sm text-red-600">{error}</p>
            )}
          </div>

          <button
            type="submit"
            disabled={!password || loading}
            className="w-full bg-green-500 text-white py-3 rounded-xl font-medium hover:bg-green-600 disabled:bg-gray-300 disabled:cursor-not-allowed transition"
          >
            {loading ? '驗證中...' : '登入'}
          </button>
        </form>

        {/* 提示 */}
        <div className="mt-6 text-center">
          <p className="text-xs text-gray-400">
            🔒 此應用受密碼保護
          </p>
        </div>
      </div>
    </div>
  );
}
